import { Directive, Input, OnInit, SimpleChanges, TemplateRef, ViewContainerRef, inject, DestroyRef } from '@angular/core';
import { RoleService } from '../../services';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { FeatureFlagsService } from '@anecdotes/feature-flags';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[visibleForRole]',
})
export class VisibleForRoleDirective implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private visibleForRoleSubject = new BehaviorSubject<string[]>([]);

  @Input()
  visibleForRole: string[];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private roleService: RoleService,
    private featureFlagsService: FeatureFlagsService,
  ) {}

  ngOnInit(): void {
    combineLatest([this.visibleForRoleSubject, this.roleService.getCurrentUserRole()]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      async ([visibleForRole, res]) => {
        // TODO: we temporarily allow rendering content for customRoles
        if (
          !visibleForRole ||
          (res.role && visibleForRole.includes(res.role)) ||
          (await this.featureFlagsService.hasPermissionAsync(visibleForRole)) || // for backward compatibility
          (await this.featureFlagsService.hasPermissionAsync('customRole')) // for backward compatibility
        ) {
          this.viewContainerRef.createEmbeddedView(this.templateRef).detectChanges();
        } else {
          this.viewContainerRef.clear();
        }
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('visibleForRole' in changes) {
      if (typeof this.visibleForRole === 'string') {
        this.visibleForRoleSubject.next([this.visibleForRole]);
      } else if (Array.isArray(this.visibleForRole)) {
        this.visibleForRoleSubject.next(this.visibleForRole);
      } else if (this.visibleForRole === undefined) {
        this.visibleForRoleSubject.next(null);
      } else {
        this.visibleForRoleSubject.next([]);
      }
    }
  }
}
